// jquery extends

$.fn.extend({
    button: function (action) {
        switch (action) {
            case "loading":
                return this.each(function () {
                    $(this).data("originalHTML", $(this).html())
                        .html($(this).data("loading-text"))
                        .attr("disabled", "disabled");
                });
            case "reset":
                return this.each(function () {
                    $(this).removeAttr("disabled")
                        .html($(this).data("originalHTML"));
                });
            default:
                break;
        }
    }
});


$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
};

String.prototype.escapeHTML = function () {
    return String(this).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s];
    });
}

export function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}